import { render, staticRenderFns } from "./Standards.vue?vue&type=template&id=cab2ad22&scoped=true&"
import script from "./Standards.vue?vue&type=script&lang=js&"
export * from "./Standards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cab2ad22",
  null
  
)

export default component.exports